import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/lib/api/errors';

/**
 * Defaults: no retry on 4xx (they will not succeed), one retry on network/5xx for reads,
 * never retry mutations (money/stock: a retry could double-submit).
 */
export function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
          return failureCount < 1;
        },
      },
      mutations: { retry: false },
    },
  });
}
